﻿window.commonUtils = function () {
	const FORMAT_PREFIX = '__format_';

	var instance = {
		getParams: function (query, raw) {
			var p = {};
			var e,
				a = /\+/g, // Regex for replacing addition symbol with a space
				r = /([^&;=]+)=?([^&;]*)/g,
				d = function (s) {
					const parm = s.replace(a, " ");
					return raw ? parm : decodeURIComponent(parm);
				},
				q = query;

			while (e = r.exec(q))
				p[d(e[1])] = d(e[2]);

			return p;
		},
		defaultFor: function (arg, val) { return typeof arg !== 'undefined' ? arg : val; },
		setFocus: function (el) {
			el.focus();
			if (el.value) {
				var strLength = el.value.length * 2;
				el.setSelectionRange(strLength, strLength);
			}
		},
		selectedOptionHints: function (args) {
			const el = document.getElementById(args.id)
			if (el) {
				const onChange = function (e) {
					var select = e.target ?? e;
					var o = select.options[select.selectedIndex];
					select.setAttribute('title', o?.textContent);
				};

				el.addEventListener('change', onChange);
				onChange(el);
			}
		},
		createGuid: function () {
			return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
				(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
			);
		},
		getScrollParent: function (element, includeHidden) {
			var style = getComputedStyle(element);
			var excludeStaticParent = style.position === "absolute";
			var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

			if (style.position === "fixed") return document.body;
			for (var parent = element; (parent = parent.parentElement);) {
				style = getComputedStyle(parent);
				if (excludeStaticParent && style.position === "static") {
					continue;
				}
				if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
			}

			return document.body;
		},
		scrollToView: function (element) {
			if (!element || !element.getBoundingClientRect) return;
			var r = element.getBoundingClientRect();
			if (r.bottom > window.innerHeight) {
				var scrl = instance.getScrollParent(element);
				if (scrl) {
					scrl.scrollTop += r.bottom - window.innerHeight + 16;
					var dy = element.getBoundingClientRect().y - scrl.getClientRects()[0].y;
					if (dy < 0)
						scrl.scrollTop += dy;
				}
				else
					window.scrollBy(0, r.bottom - window.innerHeight + 16);
			}
		},
		checkids: function () {
			var elms = document.getElementsByTagName("*"), i, len, ids = {}, id;
			for (i = 0, len = elms.length; i < len; i += 1) {
				id = elms[i].id || null;
				if (id) {
					ids[id] = ids.hasOwnProperty(id) ? ids[id] += 1 : 0;
				}
			}
			for (id in ids) {
				if (ids.hasOwnProperty(id)) {
					if (ids[id]) {
						console.warn("Multiple IDs #" + id);
					}
				}
			}
		},
		getThisOrParent: function (caller, predicate) {
			var el = caller;
			while (el) {
				if (predicate(el)) return el;
				el = el.parentNode;
				if (el instanceof HTMLBodyElement) return;
				if (el instanceof HTMLDocument) return;
			}
		},
		getParent: function (caller, predicate) {
			if (!caller.parentNode) return;
			return instance.getThisOrParent(caller.parentNode, predicate);
		},
		getRow: function (caller) {
			return instance.getThisOrParent(caller, function (el) { return el instanceof HTMLTableRowElement; });
		},
		getCell: function (caller) {
			return instance.getThisOrParent(caller, function (el) { return el instanceof HTMLTableCellElement; });
		},
		processFile: function (contenttype, disposition, data) {
			var filename = "";
			var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
			var matches = filenameRegex.exec(disposition);
			if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
			filename = decodeURIComponent(filename);

			var blob = new Blob([data], { type: contenttype });

			if (typeof window.navigator.msSaveOrOpenBlob !== 'undefined') {
				// IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
				window.navigator.msSaveOrOpenBlob(blob, filename);
			} else {
				var URL = window.URL || window.webkitURL;
				var downloadUrl = URL.createObjectURL(blob);

				if (filename) {
					// use HTML5 a[download] attribute to specify filename
					var a = document.createElement("a");
					a.href = downloadUrl;
					a.download = filename;
					a.style.display = 'none';
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				} else {
					window.location = downloadUrl;
				}

				setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
			}
		},
		processElementValue: function (el, setvalfunc) {
			if (!el) return;

			var parmname = null;
			if (el.name)
				parmname = el.name;
			else if (el.hasAttribute('data-name'))
				parmname = el.getAttribute('data-name');

			if (parmname) {
				var val = null;

				if (el.name !== undefined && el.type == 'checkbox' && !el.hasAttribute('disabled')) {
					val = el.checked;
				}
				else if (el.name != undefined && el.type == 'radio') {
					if (el.checked)
						val = el.value;
				}
				else if (el.name !== undefined && el.type == 'select-multiple' && !el.hasAttribute('disabled')) {
					parmname = parmname.replace('[]', '');
					var result = [];
					for (var i = 0, iLen = el.options.length; i < iLen; i++) {
						const opt = el.options[i];
						if (opt.selected) {
							result.push(opt.value || opt.text);
						}
					}
					val = result.join(',');
				}
				else if (el.name !== undefined && el.type == "file" && el.closest("form") !== undefined) {
					val = new FormData(el.closest("form")).get(el.name);
				}
				else if (el.name !== undefined && el.value !== undefined && !el.hasAttribute('disabled')) {
					val = el.value;
					if (val !== undefined && val != null && el.hasAttribute('data-format')) {
						setvalfunc(FORMAT_PREFIX + parmname, el.getAttribute('data-format'));
					}
				}
				else if (el.isContentEditable) {
					val = el.innerText;
				}

				if (val !== undefined && val != null) {
					setvalfunc(parmname, val);
				}
			}

			if (el.children) {
				for (var i = 0; i < el.children.length; i++) {
					instance.processElementValue(el.children[i], setvalfunc);
				}
			}
		},
		getParentOffset: function (element) {
			var offset = { top: 0, left: 0 };
			while (element && getComputedStyle(element).getPropertyValue('position') != 'fixed'
				&& getComputedStyle(element).getPropertyValue('container') == 'none') {
				element = element.offsetParent;
			}
			if (element) {
				offset.top = element.offsetTop;
				offset.left = element.offsetLeft;
			}
			return offset;
		},
		copyToClipboard: function (sourceId) {
			var source = document.querySelector('#' + sourceId);
			if (source) {
				var dummy = document.createElement("textarea");
				document.body.appendChild(dummy);
				dummy.value = source.value;
				dummy.select();
				document.execCommand("copy");
				document.body.removeChild(dummy);
			}
		},
		copyTextToClipboard: function (str) {
			var dummy = document.createElement("textarea");
			document.body.appendChild(dummy);
			dummy.value = str;
			dummy.select();
			document.execCommand("copy");
			document.body.removeChild(dummy);
		},
		clipboardToElementIdAndSubmit: function (id, submitter) {
			instance.clipboardToElementId(id).then(function () {
				ajaxUtils.formSubmit(submitter, submitter.form);
			});
		},
		clipboardToElementId: function (id) {
			return navigator.permissions.query({ name: "clipboard-read" }).then(function (result) {
				let control = document.querySelector(id);

				if (result.state == "granted" || result.state == "prompt") {
					return navigator.clipboard.readText()
						.then(function (clipText) {
							//Если тип контрола hidden, значение из буфера вставляем в value
							if (control.type === 'hidden') {
								control.value = clipText;
							}
							//Если тип контрола textarea, значение из буфера вставляем в innerText
							else if (control.type === 'textarea') {
								control.innerText = clipText;
							}
							//Другие типы контролов настраиваем по необходимости
							else {
								console.log('Control for insertion is not configured');
							}

						})
						.catch(function (err) {
							console.log('Failed to read clipboard contents: ', err);
						});
				}
				else {
					alert('В вашем браузере отключены полномочия по работе с буфером обмена. Если вы все же хотите воспользоваться данной функцией, обратитесь в службу технической поддержки.');
				}
			});
		}
	}

	return instance;
}();

if (!String.prototype.endsWith) {
	String.prototype.endsWith = function (searchString, position) {
		var subjectString = this.toString();
		if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
			position = subjectString.length;
		}
		position -= searchString.length;
		var lastIndex = subjectString.indexOf(searchString, position);
		return lastIndex !== -1 && lastIndex === position;
	};
}

if (!String.prototype.startsWith) {
	String.prototype.startsWith = function (str) {
		return this.lastIndexOf(str, 0) === 0;
	}
}

HTMLCollection.prototype.forEach = Array.prototype.forEach;
NodeList.prototype.forEach = Array.prototype.forEach;

if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function (s) {
		var el = this;
		do {
			if (Element.prototype.matches.call(el, s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}

Storage.prototype.setObject = function (key, value) {
	this.setItem(key, JSON.stringify(value));
}

Storage.prototype.getObject = function (key) {
	var value = this.getItem(key);
	return value && JSON.parse(value);
}